<template>
    <div id="step-kind" class="step">
        <div class="col-12">
            <div id="sale" class="radio-check text" v-on:click="setKind('sale')">
                <div class="image">
                    Prodej
                </div>
                <input type="radio" name="kind" required value="sale">
            </div>

            <div id="lease" class="radio-check text" v-on:click="setKind('lease')">
                <div class="image">
                    Pronájem
                </div>
                <input type="radio" name="kind" required value="lease">
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Calculation",

        data: function() {
            return {
                kind: null,
            }
        },

        mounted: function () {
            $('#step-kind .radio-check').on('click', function () {
                $('#step-kind .radio-check').removeClass('active');
                $(this).addClass('active');
                $(this).find('input').prop('checked', true);
            });
        },

        computed: {
            required: function () {
                return this.kind != null;
            }
        },

        methods: {
            setKind: function (kind) {
                $('#step-kind .radio-check').removeClass('active');
                $('#' + kind).addClass('active');
                this.kind = kind;
            },
        }
    }
</script>

<style scoped>
    input[type="radio"] {
        display: none;
    }

    .radio-check {
        cursor: pointer;
    }
</style>